<template>
  <div class="whole">
    <div class="header">
      <HeadBar></HeadBar>
    </div>
    <div class="flex">
      <div class="sidebar">
        <SlideBar></SlideBar>
      </div>
      <div class="mainContent">
        <AppMain></AppMain>
      </div>
    </div>
  </div>
</template>

<script>
import { HeadBar, SlideBar, AppMain } from "./components";
export default {
  data() {
    return {};
  },
  components: {
    HeadBar,
    SlideBar,
    AppMain,
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

img {
  display: block;
}

.whole {
  width: 100%;
  height: 100%;
}

.header {
  height: 70px;
}
</style>
